import { render, staticRenderFns } from "./QuestionsTemplate.vue?vue&type=template&id=b3b37968&"
import script from "./QuestionsTemplate.vue?vue&type=script&lang=js&"
export * from "./QuestionsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports